<section *ngIf="casoclinicoPageInformacion" class="card">
    <h2 style="text-align: center;">Casos Clínicos</h2>
    <div class="p-toolbar mb-2">
            <form [formGroup]="busquedaForm" (ngSubmit)="onSubmit()" class="busqueda-form">

                <div class="busqueda-campo">
                    <input id="firstname" pInputText type="text"
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        placeholder="Serie" formControlName="serie" />
                </div>
                <div class="busqueda-campo">
                    <input id="lastname2" pInputText type="text"
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        placeholder="Nombre del Hospital" formControlName="nombre_hospital" />
                </div>
                <div class="busqueda-acciones">
                    <p-button icon="pi pi-search" type="submit"
                        ariaLabel="Buscar casos clínicos"
                        styleClass="p-button-rounded p-button-success p-button-text p-button-raised"></p-button>
                </div>
            </form>
    </div>
    <p-toolbar styleClass="mb-4 gap-1">
        <ng-template pTemplate="center">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>

    </p-toolbar>
    <p-table [value]="casoclinicoPage" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th>Caso Clínico</th>
                <th>Parte cuerpo</th>
                <th>Hospital</th>
                <th>Medico</th>
                <th>Enfermera</th>
                <th>No. Productos</th>
                <th>No. Documentos</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-casoclinico>
            <tr>
                <td>{{casoclinico.fecha | date:'dd/MM/yyyy'}}</td>
                <td> <a [routerLink]="['/administrador/casoclinico', casoclinico.id]">{{casoclinico.serie}}</a> </td>
                <td>{{casoclinico.nomCuerpo}}</td>
                <td>{{casoclinico.nomHospital}}</td>
                <td>{{casoclinico.medico.nom_medico | uppercase}}</td>
                <td>{{casoclinico.enfermera ? (casoclinico.enfermera.nom_enfermera | uppercase) : 'Sin enfermera asignada'  }}</td>
                <td>{{casoclinico.productos.length}}</td>
                <td>{{casoclinico.documentos.length}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                No. Registros: {{casoclinicoPageInformacion.total}}, Total paginas
                {{casoclinicoPageInformacion.last_page}}
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron casos clinicos</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"></p-paginator>
    </div>
</section>
